import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { CSSGrid } from '@wix/wix-vod-shared/dist/esm/widget/ui-components/css-grid/css-grid';
import s from './switch.scss';

export class Switch extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    options: PropTypes.arrayOf({
      value: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
      className: PropTypes.string,
    }),
    onChange: PropTypes.func.isRequired,
    isRTL: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    this.id = _.uniqueId('switch-');
  }

  getOptions() {
    if (this.props.isRTL) {
      return _.reverse(this.props.options);
    }

    return this.props.options;
  }

  getInputId = (value) => `${this.id}-${value}`;

  renderOption = (option) => {
    const id = this.getInputId(option.value);

    return (
      <div className={classnames(s.option, option.className)}>
        <input
          type="radio"
          name={this.props.name}
          value={option.value}
          id={id}
          onChange={this.props.onChange}
          checked={this.props.value === option.value}
        />
        <label htmlFor={id} className={option.className}>
          {option.label}
        </label>
      </div>
    );
  };

  renderIndicator() {
    const options = this.getOptions();
    const index = _.findIndex(
      this.props.options,
      (option) => option.value === this.props.value,
    );
    const width = 100 / options.length;
    const style = {
      width: `${width}%`,
      transform: `translateX(${
        index * width * 2 + (this.props.isRTL ? -100 : 0)
      }%)`,
    };

    return <div className={s.indicator} style={style} />;
  }

  render() {
    return (
      <div className={s.container}>
        <CSSGrid gridId="switch" styleId="switch" rows={1} cols={2}>
          {this.getOptions().map(this.renderOption)}
        </CSSGrid>
        {this.renderIndicator()}
      </div>
    );
  }
}
